import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class ConnectBasicEntity extends BasicEntity {
code: string;
}

